import axios from 'axios';
import { AnaliticModel } from './Analitics.types';

export async function userAction(body: AnaliticModel) {
    const data = await axios.post(`${process.env.REACT_APP_API_PATH}analytic/create/`, body);
    return data;
}
